var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosedCircle = function SvgClosedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.126 5.126a.43.43 0 0 1 .606 0L8 7.394l2.268-2.268a.429.429 0 0 1 .606.606L8.607 8l2.268 2.268a.429.429 0 0 1-.606.606L8 8.607l-2.268 2.268a.429.429 0 0 1-.606-.606L7.394 8 5.126 5.732a.43.43 0 0 1 0-.606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .5c4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5S.5 12.136.5 8 3.864.5 8 .5m0 .882a6.618 6.618 0 1 0 0 13.236A6.618 6.618 0 0 0 8 1.382"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgClosedCircle;